import { IKeyValueInterface } from "./../../shared/config";
import { ReportDamage } from "./../models/reportdamage.model";
import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import { SVGVehicleModel } from "./../../vehicle/models/vehicle.model";
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  OnChanges
} from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Router } from "@angular/router";
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  UserRoles,
  DataListModel
} from "../../shared/config";
import { FileUploader } from "ng2-file-upload";
import { ReportDamageService } from "../models/report-damage.service";
declare var $: any;

@Component({
  selector: "wego-report-damage-popup",
  template: require('../views/report-damage-popup.component.html'),
  providers: [ReportDamageService]
})
export class ReportDamagePopupComponent implements OnInit, OnChanges {
  public fileToUpload: File[];
  public isLoading: boolean;
  public headers: any;
  public uploader: FileUploader;
  public model: ReportDamage;
  public errorModel: IKeyValueInterface[];
  public errorMsg: string;

  @Output("OnSuccessSelect") onSuccessSelect = new EventEmitter();

  @ViewChild("reportDamageModal") public reportDamageModal: any;
  @ViewChild("imageFile") public imageFile: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService,
    private reportDamageService: ReportDamageService
  ) {}

  ngOnInit() {
    this.model = new ReportDamage();
  }

  ngOnChanges(change: any) {
    console.log(change);
  }

  public show(): void {
    this.errorMsg = "";
    this.errorModel = [];
    this.model.damagecause = "";
    this.model.damagedescription = "";
    this.ClearFileInput();
    this.reportDamageModal.show();
  }

  public hide(): void {
    this.reportDamageModal.hide();
  }

  private OnSuccessSelect() {
    this.hide();
    let successMsg = this.translate.instant("LblReportDamageMsg");
    this.onSuccessSelect.emit({ SuccessMessage: successMsg });
  }

  // public HandleOnAfterAddingFile(fileItem: any) {
  //   if (this.uploader.queue.length > 1) {
  //     this.uploader.queue.forEach(element => {
  //       element.remove();
  //     });
  //   }
  // }

  public HandleOnBuildItemForm(fileItem: any, Form: any) {
    Form.append("reportdamage", JSON.stringify(this.model));
  }

  public HandleOnCompleteItem(
    item: any,
    response: any,
    status: any,
    headers: any
  ) {
    let apiresponse = JSON.parse(response);
    console.log(apiresponse);
    if (status == 200) {
      if (apiresponse.data) {
        this.OnSuccessSelect();
        console.log("Success");
      } else {
        if (typeof apiresponse.error === "string") {
          this.errorMsg = apiresponse.error;
        } else {
          this.errorModel = apiresponse.error;
        }
      }
    } else {
      this.errorMsg = this.authService.HandleErrorStatusCode(status);
    }
    this.isLoading = false;
    this.ClearFileInput();
  }

  public ClearFileInput() {
    // console.log(this.imageFile);
    // if (this.imageFile.nativeElement) {
    //   console.log(this.imageFile.nativeElement.value);
    //   this.imageFile.nativeElement.value = "";
    //   this.uploader.clearQueue();
    // }

  }

  public HandleFileInput(files: FileList) {
    this.fileToUpload = [];
    for (var i = 0; i < files.length; i++) {
      this.fileToUpload.push(files.item(i));
    }
  }

  // public OnSubmit(forms: any) {
  //   if (
  //     this.uploader &&
  //     this.uploader.queue &&
  //     this.uploader.queue.length > 0
  //   ) {
  //     this.isLoading = true;
  //     this.errorMsg = "";
  //     this.uploader.uploadAll();
  //   } else {
  //     this.errorMsg = this.translate.instant("LblSelectFile");
  //   }
  // }

  private UpdateReportDamage() {
    if (!this.fileToUpload) {
      this.isLoading = false;
      this.errorMsg = this.translate.instant("LblSelectFile");
      return;
    }
    const formData = new FormData();
    formData.append("reportdamage", JSON.stringify(this.model));

    for (let index = 0; index < this.fileToUpload.length; index++) {
      formData.append(
        "file" + index,
        this.fileToUpload[index],
        this.fileToUpload[index].name
      );
    }

    this.reportDamageService.UpdateDamageReport(formData).subscribe(
      res => {
        if (res.data) {
          this.OnSuccessSelect();
        } else {
          this.errorModel = res.error;
        }
      },
      error => {
        console.log(error);
        this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public OnCancel($event: any) {
    this.hide();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/components/report-damage-popup.component.ts